module.exports = __webpack_public_path__ + "static/img/map-pattern-footer.2fc11129.png";